import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'
import toast from 'react-hot-toast'

const TCMS_STYLES = `
  .tcms-hero { background:linear-gradient(135deg,#4D4E8D,#41427a); color:#fff; border-radius:16px; padding:24px 28px; margin-bottom:20px; position:relative; overflow:hidden; }
  .tcms-hero::before { content:''; position:absolute; top:-50%; right:-10%; width:400px; height:400px; background:radial-gradient(circle,rgba(168,124,232,0.18),transparent 70%); pointer-events:none; }
  .tcms-hero-title { font-family:'Plus Jakarta Sans',sans-serif; font-size:26px; font-weight:600; color:#fff; margin:0 0 6px; position:relative; }
  .tcms-hero-sub { font-size:13px; color:rgba(255,255,255,0.7); line-height:1.6; position:relative; }

  .tcms-tabs { display:flex; gap:0; border-bottom:2px solid #E2E4E7; margin-bottom:20px; flex-wrap:wrap; }
  .tcms-tab { padding:10px 18px; font-size:13px; font-weight:600; cursor:pointer; border:none; background:none; color:#5C6065; border-bottom:3px solid transparent; margin-bottom:-2px; transition:all 0.15s; font-family:inherit; white-space:nowrap; display:flex; align-items:center; gap:6px; }
  .tcms-tab:hover { color:#151715; }
  .tcms-tab.active { color:#151715; border-bottom-color:#6E70AE; }
  .tcms-tab-badge { background:#E24B4A; color:#fff; font-size:10px; font-weight:700; padding:1px 7px; border-radius:10px; }

  .tcms-card { background:#fff; border:1px solid #E2E4E7; border-radius:14px; overflow:hidden; margin-bottom:14px; }
  .tcms-card-header { padding:14px 18px; background:#F5F6F7; border-bottom:1px solid #E2E4E7; display:flex; align-items:center; justify-content:space-between; gap:8px; flex-wrap:wrap; }
  .tcms-card-title { font-size:13px; font-weight:600; color:#151715; }
  .tcms-card-body { padding:18px; }

  .tcms-form { display:flex; flex-direction:column; gap:12px; }
  .tcms-label { font-size:11px; font-weight:600; color:#5C6065; letter-spacing:0.06em; margin-bottom:4px; display:block; }
  .tcms-input, .tcms-textarea, .tcms-select { width:100%; padding:10px 12px; border:1.5px solid #D7DADE; border-radius:8px; font-size:13px; font-family:inherit; box-sizing:border-box; background:#fff; }
  .tcms-input:focus, .tcms-textarea:focus, .tcms-select:focus { outline:none; border-color:#6E70AE; }
  .tcms-textarea { resize:vertical; min-height:80px; line-height:1.6; }

  .tcms-btn-primary { padding:10px 20px; border-radius:8px; border:none; background:linear-gradient(135deg,#6E70AE,#4D4E8D); color:#fff; cursor:pointer; font-size:13px; font-weight:600; font-family:inherit; }
  .tcms-btn-primary:hover:not(:disabled) { background:linear-gradient(135deg,#4D4E8D,#6E70AE); }
  .tcms-btn-primary:disabled { opacity:0.5; cursor:not-allowed; }
  .tcms-btn-ghost { padding:8px 16px; border-radius:8px; background:none; border:1px solid #D7DADE; color:#5C6065; cursor:pointer; font-size:12px; font-family:inherit; }
  .tcms-btn-icon { background:none; border:none; cursor:pointer; padding:4px 8px; border-radius:6px; font-size:14px; }
  .tcms-btn-icon:hover { background:#EEEFF1; }

  .tcms-row { padding:14px 18px; border-bottom:1px solid #EEEFF1; display:flex; gap:12px; align-items:flex-start; }
  .tcms-row:last-child { border-bottom:none; }
  .tcms-row:hover { background:#F7F8F9; }

  .tcms-badge { font-size:10px; font-weight:700; padding:2px 8px; border-radius:10px; letter-spacing:0.04em; }
  .tcms-badge.ceo { background:#6E70AE; color:#fff; }
  .tcms-badge.pinned { background:#4D4E8D; color:#fff; }
  .tcms-badge.member { background:#E2E4E7; color:#3A3D40; }
  .tcms-badge.new { background:#E24B4A; color:#fff; }
  .tcms-badge.researching { background:#EEF0F8; color:#41427a; }
  .tcms-badge.building { background:#EAF2EE; color:#5E8A72; }
  .tcms-badge.shipped { background:#6E70AE; color:#fff; }
  .tcms-badge.archived { background:#EEEFF1; color:#A2A6AA; }

  .tcms-pp-card { border:1px solid #E2E4E7; border-radius:12px; padding:16px; margin-bottom:12px; background:#fff; }
  .tcms-pp-head { display:flex; justify-content:space-between; align-items:flex-start; gap:12px; flex-wrap:wrap; margin-bottom:10px; }
  .tcms-pp-meta { font-size:11px; color:#5C6065; }
  .tcms-pp-text { font-size:13px; color:#1A1A1A; line-height:1.7; white-space:pre-line; padding:10px; background:#F7F8F9; border-radius:8px; margin-top:8px; }
  .tcms-pp-fix { font-size:12px; color:#3A3D40; line-height:1.6; padding:8px 12px; background:#F0F4FF; border-left:3px solid #4B5EAA; border-radius:6px; margin-top:8px; white-space:pre-line; }

  .tcms-empty { text-align:center; padding:50px 20px; color:#A2A6AA; }
  .tcms-empty-icon { font-size:48px; margin-bottom:12px; opacity:0.6; }

  .tcms-stat-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(160px,1fr)); gap:12px; margin-bottom:20px; }
  .tcms-stat-card { background:#fff; border:1px solid #E2E4E7; border-radius:12px; padding:14px 16px; }
  .tcms-stat-label { font-size:10px; font-weight:600; color:#5C6065; letter-spacing:0.08em; margin-bottom:6px; }
  .tcms-stat-value { font-family:'Plus Jakarta Sans',sans-serif; font-size:28px; font-weight:600; color:#151715; line-height:1; }
  .tcms-stat-sub { font-size:11px; color:#A2A6AA; margin-top:4px; }

  .tcms-check { display:flex; align-items:center; gap:8px; cursor:pointer; font-size:13px; color:#3A3D40; }
`

const PAIN_CATEGORIES = {
  general:          'General',
  tech:             '🛠️ Tech / Platform',
  client:           '🤝 Client / Borrower',
  regulation:       '⚖️ Regulation',
  feature_request:  '💡 Feature Request',
  other:            '❓ Other',
}

const PP_STATUSES = ['new', 'researching', 'building', 'shipped', 'archived']
const CS_STATUSES = ['planned', 'researching', 'building', 'shipped']

function timeAgo(date) {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000)
  if (seconds < 60) return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days}d ago`
  return new Date(date).toLocaleDateString()
}

// ─── MANAGE POSTS TAB ─────────────────────────────────────────────
function ManagePostsTab({ userId }) {
  const [posts,     setPosts]     = useState([])
  const [loading,   setLoading]   = useState(true)
  const [composing, setComposing] = useState('')
  const [pinning,   setPinning]   = useState(true)
  const [posting,   setPosting]   = useState(false)

  useEffect(() => { load() }, [])

  async function load() {
    try {
      const { data } = await supabase
        .from('tribe_posts')
        .select('*, author:profiles!tribe_posts_author_id_fkey(full_name)')
        .order('is_pinned', { ascending: false })
        .order('created_at', { ascending: false })
        .limit(100)
      setPosts(data || [])
    } catch (err) {
      console.warn('[TribeCMS] posts load error:', err.message)
    } finally {
      setLoading(false)
    }
  }

  async function publishCEO() {
    if (!composing.trim() || !userId) return
    setPosting(true)
    try {
      const { error } = await supabase.from('tribe_posts').insert({
        author_id:   userId,
        content:     composing.trim(),
        is_ceo_post: true,
        is_pinned:   pinning,
      })
      if (error) throw error
      toast.success('🎉 CEO post published to the tribe!!')
      setComposing('')
      load()
    } catch (err) {
      toast.error(err.message)
    } finally {
      setPosting(false)
    }
  }

  async function togglePin(p) {
    await supabase.from('tribe_posts').update({ is_pinned: !p.is_pinned }).eq('id', p.id)
    toast.success(p.is_pinned ? 'Unpinned' : '📌 Pinned to top of feed')
    load()
  }

  async function deletePost(p) {
    if (!window.confirm(`Delete this post?\n\n"${p.content.slice(0,80)}${p.content.length>80?'...':''}"`)) return
    await supabase.from('tribe_posts').delete().eq('id', p.id)
    toast.success('Post deleted')
    load()
  }

  if (loading) return <div className="tcms-empty">Loading posts...</div>

  return (
    <>
      <div className="tcms-card">
        <div className="tcms-card-header">
          <span className="tcms-card-title">💜 Post as CEO</span>
        </div>
        <div className="tcms-card-body">
          <div className="tcms-form">
            <textarea
              className="tcms-textarea"
              placeholder="Speak to your tribe... share a win, drop wisdom, celebrate someone!!"
              value={composing}
              onChange={e => setComposing(e.target.value)}
              style={{ minHeight: 110 }}
            />
            <label className="tcms-check">
              <input type="checkbox" checked={pinning} onChange={e => setPinning(e.target.checked)} style={{ width:'auto' }} />
              <span>📌 Pin to top of feed (recommended for important announcements)</span>
            </label>
            <div style={{ display:'flex', justifyContent:'flex-end' }}>
              <button className="tcms-btn-primary" onClick={publishCEO} disabled={!composing.trim() || posting}>
                {posting ? 'Publishing...' : '🚀 Publish to Tribe'}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="tcms-card">
        <div className="tcms-card-header">
          <span className="tcms-card-title">📰 All Tribe Posts ({posts.length})</span>
        </div>
        {posts.length === 0 ? (
          <div className="tcms-empty">
            <div className="tcms-empty-icon">📰</div>
            <div>No posts yet. Be the first — write one above!!</div>
          </div>
        ) : posts.map(p => (
          <div key={p.id} className="tcms-row">
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6, flexWrap:'wrap' }}>
                <strong style={{ fontSize:13, color:'#151715' }}>{p.author?.full_name || 'Unknown'}</strong>
                {p.is_ceo_post && <span className="tcms-badge ceo">💜 CEO</span>}
                {!p.is_ceo_post && <span className="tcms-badge member">MEMBER</span>}
                {p.is_pinned && <span className="tcms-badge pinned">📌 PINNED</span>}
                <span style={{ fontSize:11, color:'#A2A6AA' }}>{timeAgo(p.created_at)}</span>
              </div>
              <div style={{ fontSize:13, color:'#3A3D40', lineHeight:1.6, whiteSpace:'pre-line', wordWrap:'break-word' }}>{p.content}</div>
            </div>
            <div style={{ display:'flex', gap:4, flexShrink:0 }}>
              <button className="tcms-btn-icon" onClick={() => togglePin(p)} title={p.is_pinned ? 'Unpin' : 'Pin to top'}>{p.is_pinned ? '📌' : '📍'}</button>
              <button className="tcms-btn-icon" onClick={() => deletePost(p)} style={{ color:'#E24B4A' }} title="Delete">🗑️</button>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

// ─── MANAGE COMING SOON TAB ───────────────────────────────────────
function ManageComingSoonTab() {
  const [features, setFeatures] = useState([])
  const [loading,  setLoading]  = useState(true)
  const [editing,  setEditing]  = useState(null)
  const [form,     setForm]     = useState({ title:'', description:'', icon:'⭐', status:'planned', sort_order:0, published:true })
  const [saving,   setSaving]   = useState(false)
  const [voteCounts, setVoteCounts] = useState({})

  useEffect(() => { load() }, [])

  async function load() {
    try {
      const { data: feats } = await supabase.from('tribe_feature_requests').select('*').order('sort_order', { ascending: true })
      setFeatures(feats || [])

      if (feats && feats.length > 0) {
        const ids = feats.map(f => f.id)
        const { data: votes } = await supabase.from('tribe_feature_votes').select('feature_id').in('feature_id', ids)
        const counts = {}
        ids.forEach(id => { counts[id] = 0 })
        ;(votes || []).forEach(v => { counts[v.feature_id] = (counts[v.feature_id] || 0) + 1 })
        setVoteCounts(counts)
      }
    } catch (err) {
      console.warn('[TribeCMS] features load:', err.message)
    } finally {
      setLoading(false)
    }
  }

  function openNew() {
    setForm({ title:'', description:'', icon:'⭐', status:'planned', sort_order: features.length + 1, published:true })
    setEditing('new')
  }

  function openEdit(f) {
    setForm({ title:f.title, description:f.description||'', icon:f.icon||'⭐', status:f.status||'planned', sort_order:f.sort_order||0, published:!!f.published })
    setEditing(f)
  }

  async function save() {
    if (!form.title.trim()) { toast.error('Title is required!!'); return }
    setSaving(true)
    try {
      const payload = {
        title:       form.title.trim(),
        description: form.description.trim() || null,
        icon:        form.icon || '⭐',
        status:      form.status,
        sort_order:  Number(form.sort_order) || 0,
        published:   form.published,
        updated_at:  new Date().toISOString(),
      }
      if (editing === 'new') {
        const { error } = await supabase.from('tribe_feature_requests').insert(payload)
        if (error) throw error
        toast.success('✅ Sneak preview added!!')
      } else {
        const { error } = await supabase.from('tribe_feature_requests').update(payload).eq('id', editing.id)
        if (error) throw error
        toast.success('✅ Sneak preview updated!!')
      }
      setEditing(null)
      load()
    } catch (err) {
      toast.error(err.message)
    } finally {
      setSaving(false)
    }
  }

  async function deleteFeature(f) {
    if (!window.confirm(`Delete "${f.title}"?`)) return
    await supabase.from('tribe_feature_requests').delete().eq('id', f.id)
    toast.success('Deleted')
    load()
  }

  if (loading) return <div className="tcms-empty">Loading sneak previews...</div>

  return (
    <>
      {editing && (
        <div className="tcms-card" style={{ border:'2px solid #6E70AE' }}>
          <div className="tcms-card-header">
            <span className="tcms-card-title">{editing === 'new' ? '➕ Add Sneak Preview' : `✏️ Edit: ${editing.title}`}</span>
            <button className="tcms-btn-icon" onClick={() => setEditing(null)}>✕</button>
          </div>
          <div className="tcms-card-body">
            <div className="tcms-form">
              <div>
                <label className="tcms-label">TITLE *</label>
                <input className="tcms-input" placeholder="e.g. Discussion Channels" value={form.title} onChange={e => setForm(f => ({ ...f, title:e.target.value }))} />
              </div>
              <div>
                <label className="tcms-label">DESCRIPTION</label>
                <textarea className="tcms-textarea" placeholder="What is this feature about??" value={form.description} onChange={e => setForm(f => ({ ...f, description:e.target.value }))} />
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
                <div>
                  <label className="tcms-label">ICON (emoji)</label>
                  <input className="tcms-input" maxLength={4} value={form.icon} onChange={e => setForm(f => ({ ...f, icon:e.target.value }))} />
                </div>
                <div>
                  <label className="tcms-label">STATUS</label>
                  <select className="tcms-select" value={form.status} onChange={e => setForm(f => ({ ...f, status:e.target.value }))}>
                    {CS_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <div>
                  <label className="tcms-label">SORT ORDER</label>
                  <input className="tcms-input" type="number" value={form.sort_order} onChange={e => setForm(f => ({ ...f, sort_order:e.target.value }))} />
                </div>
              </div>
              <label className="tcms-check">
                <input type="checkbox" checked={form.published} onChange={e => setForm(f => ({ ...f, published:e.target.checked }))} style={{ width:'auto' }} />
                <span>Published (visible to tribe)</span>
              </label>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
                <button className="tcms-btn-ghost" onClick={() => setEditing(null)}>Cancel</button>
                <button className="tcms-btn-primary" onClick={save} disabled={saving}>{saving ? 'Saving...' : '✅ Save'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="tcms-card">
        <div className="tcms-card-header">
          <span className="tcms-card-title">🚪 Coming Soon Lounge ({features.length} items)</span>
          <button className="tcms-btn-primary" onClick={openNew}>➕ Add Sneak Preview</button>
        </div>
        {features.length === 0 ? (
          <div className="tcms-empty">
            <div className="tcms-empty-icon">🚪</div>
            <div>No sneak previews yet!!</div>
          </div>
        ) : features.map(f => (
          <div key={f.id} className="tcms-row">
            <div style={{ fontSize:24, flexShrink:0 }}>{f.icon || '⭐'}</div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', marginBottom:4 }}>
                <strong style={{ fontSize:13, color:'#151715' }}>{f.title}</strong>
                <span className={`tcms-badge ${f.status}`}>{f.status.toUpperCase()}</span>
                <span style={{ fontSize:11, color:'#6E70AE', fontWeight:600 }}>🗳️ {voteCounts[f.id] || 0} vote{(voteCounts[f.id] || 0) !== 1 ? 's' : ''}</span>
                {!f.published && <span className="tcms-badge archived">HIDDEN</span>}
              </div>
              {f.description && <div style={{ fontSize:12, color:'#5C6065', lineHeight:1.5 }}>{f.description}</div>}
            </div>
            <div style={{ display:'flex', gap:4, flexShrink:0 }}>
              <button className="tcms-btn-icon" onClick={() => openEdit(f)}>✏️</button>
              <button className="tcms-btn-icon" onClick={() => deleteFeature(f)} style={{ color:'#E24B4A' }}>🗑️</button>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

// ─── PAIN POINTS INBOX TAB ────────────────────────────────────────
function PainPointsInbox() {
  const [points,  setPoints]  = useState([])
  const [loading, setLoading] = useState(true)
  const [filter,  setFilter]  = useState('new')
  const [savingNote, setSavingNote] = useState(null)
  const [noteEdits, setNoteEdits] = useState({}) // id -> string

  useEffect(() => { load() }, [])

  async function load() {
    try {
      const { data } = await supabase
        .from('tribe_pain_points')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(200)
      setPoints(data || [])
      const notes = {}
      ;(data || []).forEach(p => { notes[p.id] = p.admin_notes || '' })
      setNoteEdits(notes)
    } catch (err) {
      console.warn('[TribeCMS] pain points load:', err.message)
    } finally {
      setLoading(false)
    }
  }

  async function updateStatus(p, newStatus) {
    await supabase.from('tribe_pain_points').update({ status: newStatus, updated_at: new Date().toISOString() }).eq('id', p.id)
    toast.success(`Marked as ${newStatus}`)
    load()
  }

  async function saveNote(p) {
    setSavingNote(p.id)
    try {
      await supabase.from('tribe_pain_points').update({ admin_notes: noteEdits[p.id] || null, updated_at: new Date().toISOString() }).eq('id', p.id)
      toast.success('Note saved 🔒')
    } catch (err) {
      toast.error(err.message)
    } finally {
      setSavingNote(null)
    }
  }

  const filtered = points.filter(p => filter === 'all' ? true : p.status === filter)
  const counts = PP_STATUSES.reduce((acc, s) => ({ ...acc, [s]: points.filter(p => p.status === s).length }), {})

  if (loading) return <div className="tcms-empty">Loading pain points...</div>

  return (
    <>
      <div className="tcms-stat-grid">
        {PP_STATUSES.map(s => (
          <div key={s} className="tcms-stat-card" style={{ cursor:'pointer', borderColor: filter === s ? '#6E70AE' : '#E2E4E7' }} onClick={() => setFilter(s)}>
            <div className="tcms-stat-label">{s.toUpperCase()}</div>
            <div className="tcms-stat-value" style={{ color: filter === s ? '#6E70AE' : '#151715' }}>{counts[s] || 0}</div>
            <div className="tcms-stat-sub">click to filter</div>
          </div>
        ))}
        <div className="tcms-stat-card" style={{ cursor:'pointer', borderColor: filter === 'all' ? '#6E70AE' : '#E2E4E7' }} onClick={() => setFilter('all')}>
          <div className="tcms-stat-label">ALL</div>
          <div className="tcms-stat-value" style={{ color: filter === 'all' ? '#6E70AE' : '#151715' }}>{points.length}</div>
          <div className="tcms-stat-sub">total submissions</div>
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="tcms-card">
          <div className="tcms-empty">
            <div className="tcms-empty-icon">💚</div>
            <div>{filter === 'new' ? 'No new pain points right now — your tribe is happy!!' : `No items with status "${filter}".`}</div>
          </div>
        </div>
      ) : filtered.map(p => (
        <div key={p.id} className="tcms-pp-card">
          <div className="tcms-pp-head">
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                <strong style={{ fontSize:13, color:'#151715' }}>
                  {p.is_anonymous ? '🤫 Anonymous' : (p.author_name || 'Tribe Member')}
                </strong>
                <span className="tcms-badge member">{PAIN_CATEGORIES[p.category] || p.category}</span>
                <span className={`tcms-badge ${p.status}`}>{p.status.toUpperCase()}</span>
              </div>
              <div className="tcms-pp-meta" style={{ marginTop:4 }}>{timeAgo(p.created_at)}</div>
            </div>
            <select className="tcms-select" style={{ width:160 }} value={p.status} onChange={e => updateStatus(p, e.target.value)}>
              {PP_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>

          <div className="tcms-pp-text"><strong>😣 Pain:</strong> {p.pain_point}</div>
          {p.ideal_fix && <div className="tcms-pp-fix"><strong>💡 Ideal fix:</strong> {p.ideal_fix}</div>}

          <div style={{ marginTop:12 }}>
            <label className="tcms-label">🔒 PRIVATE ADMIN NOTES</label>
            <textarea
              className="tcms-textarea"
              placeholder="Notes only you see..."
              value={noteEdits[p.id] || ''}
              onChange={e => setNoteEdits(prev => ({ ...prev, [p.id]: e.target.value }))}
              style={{ minHeight: 60 }}
            />
            <div style={{ display:'flex', justifyContent:'flex-end', marginTop:8 }}>
              <button className="tcms-btn-primary" onClick={() => saveNote(p)} disabled={savingNote === p.id}>
                {savingNote === p.id ? 'Saving...' : '💾 Save Note'}
              </button>
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

// ─── ANALYTICS TAB ────────────────────────────────────────────────
function AnalyticsTab() {
  const [stats, setStats] = useState({ posts:0, comments:0, likes:0, members:0, painNew:0, painTotal:0, votes:0 })
  const [loading, setLoading] = useState(true)
  const [topVoted, setTopVoted] = useState([])

  useEffect(() => { load() }, [])

  async function load() {
    try {
      const safeCount = async (table, filters) => {
        try {
          let q = supabase.from(table).select('*', { count:'exact', head:true })
          if (filters) Object.entries(filters).forEach(([k,v]) => { q = q.eq(k, v) })
          const { count } = await q
          return count || 0
        } catch { return 0 }
      }

      const [posts, comments, likes, members, painNew, painTotal, votes] = await Promise.all([
        safeCount('tribe_posts'),
        safeCount('tribe_post_comments'),
        safeCount('tribe_post_likes'),
        safeCount('profiles', { role:'notary', is_approved:true }),
        safeCount('tribe_pain_points', { status:'new' }),
        safeCount('tribe_pain_points'),
        safeCount('tribe_feature_votes'),
      ])
      setStats({ posts, comments, likes, members, painNew, painTotal, votes })

      // Top voted features
      const { data: feats } = await supabase.from('tribe_feature_requests').select('*').eq('published', true)
      if (feats && feats.length > 0) {
        const ids = feats.map(f => f.id)
        const { data: allVotes } = await supabase.from('tribe_feature_votes').select('feature_id').in('feature_id', ids)
        const counts = {}
        ids.forEach(id => { counts[id] = 0 })
        ;(allVotes || []).forEach(v => { counts[v.feature_id] = (counts[v.feature_id] || 0) + 1 })
        const sorted = feats.map(f => ({ ...f, votes: counts[f.id] || 0 })).sort((a, b) => b.votes - a.votes).slice(0, 5)
        setTopVoted(sorted)
      }
    } catch (err) {
      console.warn('[TribeCMS] analytics load:', err.message)
    } finally {
      setLoading(false)
    }
  }

  if (loading) return <div className="tcms-empty">Loading tribe analytics...</div>

  return (
    <>
      <div className="tcms-stat-grid">
        <div className="tcms-stat-card"><div className="tcms-stat-label">TRIBE MEMBERS</div><div className="tcms-stat-value">{stats.members}</div><div className="tcms-stat-sub">approved notaries</div></div>
        <div className="tcms-stat-card"><div className="tcms-stat-label">POSTS</div><div className="tcms-stat-value">{stats.posts}</div><div className="tcms-stat-sub">in the feed</div></div>
        <div className="tcms-stat-card"><div className="tcms-stat-label">COMMENTS</div><div className="tcms-stat-value">{stats.comments}</div><div className="tcms-stat-sub">conversations</div></div>
        <div className="tcms-stat-card"><div className="tcms-stat-label">LIKES</div><div className="tcms-stat-value">{stats.likes}</div><div className="tcms-stat-sub">love given</div></div>
        <div className="tcms-stat-card" style={{ borderColor: stats.painNew > 0 ? '#E24B4A' : '#E2E4E7' }}>
          <div className="tcms-stat-label">PAIN POINTS</div>
          <div className="tcms-stat-value" style={{ color: stats.painNew > 0 ? '#E24B4A' : '#151715' }}>{stats.painNew}</div>
          <div className="tcms-stat-sub">new ({stats.painTotal} total)</div>
        </div>
        <div className="tcms-stat-card"><div className="tcms-stat-label">FEATURE VOTES</div><div className="tcms-stat-value">{stats.votes}</div><div className="tcms-stat-sub">voices heard</div></div>
      </div>

      <div className="tcms-card">
        <div className="tcms-card-header"><span className="tcms-card-title">🏆 Top Voted Features</span></div>
        {topVoted.length === 0 ? (
          <div className="tcms-empty">
            <div className="tcms-empty-icon">🗳️</div>
            <div>No votes yet — the tribe hasn't spoken!!</div>
          </div>
        ) : topVoted.map((f, idx) => (
          <div key={f.id} className="tcms-row">
            <div style={{ fontSize:18, color:'#4D4E8D', fontWeight:700, minWidth:30 }}>#{idx + 1}</div>
            <div style={{ fontSize:24, flexShrink:0 }}>{f.icon}</div>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:13, fontWeight:600, color:'#151715' }}>{f.title}</div>
              <div style={{ fontSize:11, color:'#5C6065' }}>{f.description}</div>
            </div>
            <div style={{ fontSize:14, fontWeight:700, color:'#6E70AE' }}>🗳️ {f.votes}</div>
          </div>
        ))}
      </div>
    </>
  )
}

// ─── MAIN ─────────────────────────────────────────────────────────
export default function TribeCMS() {
  const { user } = useAuth() || {}
  const [tab, setTab] = useState('posts')
  const [newPainCount, setNewPainCount] = useState(0)

  useEffect(() => {
    async function check() {
      try {
        const { count } = await supabase.from('tribe_pain_points').select('*', { count:'exact', head:true }).eq('status', 'new')
        setNewPainCount(count || 0)
      } catch {}
    }
    check()
  }, [tab])

  return (
    <>
      <style>{TCMS_STYLES}</style>
      <div className="tcms-hero">
        <div className="tcms-hero-title">💜 The Lounge Command Center</div>
        <div className="tcms-hero-sub">Manage the NSV Tribe — post as CEO, curate sneak previews, harvest pain points into gold, and track the pulse of your community!!</div>
      </div>

      <div className="tcms-tabs">
        <button className={`tcms-tab${tab==='posts'?' active':''}`} onClick={() => setTab('posts')}>📰 Manage Posts</button>
        <button className={`tcms-tab${tab==='coming-soon'?' active':''}`} onClick={() => setTab('coming-soon')}>🚪 Coming Soon</button>
        <button className={`tcms-tab${tab==='pain-points'?' active':''}`} onClick={() => setTab('pain-points')}>
          🆘 Pain Points
          {newPainCount > 0 && <span className="tcms-tab-badge">{newPainCount}</span>}
        </button>
        <button className={`tcms-tab${tab==='analytics'?' active':''}`} onClick={() => setTab('analytics')}>📊 Analytics</button>
      </div>

      {tab === 'posts'        && <ManagePostsTab userId={user?.id} />}
      {tab === 'coming-soon'  && <ManageComingSoonTab />}
      {tab === 'pain-points'  && <PainPointsInbox />}
      {tab === 'analytics'    && <AnalyticsTab />}
    </>
  )
}
